export default "__VITE_ASSET__vYH4Yhxi__"